module.exports = __webpack_public_path__ + "img/行业证书.59df1788.png";